import kebabCase from "lodash/kebabCase";

export function slugify(text: string): string {
    return kebabCase(text.toLowerCase().replace(/[&+]/g, "-and-"));
}

// Wraps any backtick enclosed text in a <code> tag.
// Example: Some text with `code` -> Some text with <code>code</code>
export function codify(text?: string): string {
    const parts: Array<string> = text?.split(/`([^`]+)`/gi) || [];
    for (let i = 1; i < parts.length; i += 2) {
        parts[i] = `<code>${parts[i]}</code>`;
    }

    return parts.join("");
}
